<template>
  <PrintableCertificate/>
</template>

<script>
import PrintableCertificate from '../PrintableCertificate.vue';

export default {
  name: 'course-certificate',
  components: {
    PrintableCertificate,
  },
};
</script>
